<div class="field">
  <label for="emails" class="col-fixed align-top title-row input-title">{{translate(this.boxName)}}</label>
  <div class="col input-row">
    <p-autoComplete id="emails" styleClass="tags"  [forceSelection]="true" appendTo="body" [multiple]="true"
                    [completeOnFocus]="false" [ngModel]="emails" (ngModelChange)="onModelChange($event)" [suggestions]="users"
                    (completeMethod)="emailsComplete($event)" [placeholder]="emails.length === 0 ? translate('EMAIL_PLACEHOLDER') : ''">
    </p-autoComplete>
  </div>
</div>
